import { Filter } from "lucide-react";
import { useMapStore } from "../store";

function FilterButton({showActive}: {showActive?: boolean}) {
    const { display, setDisplay } = useMapStore();
    const isExpanded = display === "filter";
    
    const handleClick = () => {
        setDisplay(isExpanded ? null : "filter");
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Escape' && isExpanded) {
            setDisplay(null);
        }
    }
    return (
        <>
            <button 
                onClick={handleClick}
                onKeyDown={handleKeyDown}
                className={`${showActive && isExpanded ? 'bg-ocean-700' : 'bg-transparent'} flex flex-col items-center justify-center gap-2 text-center w-full h-full text-h6 font-semibold text-white ${showActive ? 'outline-offset-[-4px] active:bg-ocean-700' : 'px-4'} !outline-white`}
                aria-expanded={isExpanded}
                aria-controls="map_filter"
                id="map_filter_button"
                aria-haspopup="dialog"
            >
                <div aria-hidden="true">
                <Filter size={28} />
                  {/* <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="32.182" height="30.654"><path fill="#fff" d="M11.072 30.654a1.252 1.252 0 0 1-1.253-1.274l.212-11.809-9.84-15.65A1.253 1.253 0 0 1 1.253 0h18.11a1.254 1.254 0 1 1 0 2.507H3.521l8.832 14.046a1.249 1.249 0 0 1 .191.689l-.182 10.175 7.276-3.4V17.4a1.252 1.252 0 0 1 .19-.661l8.845-14.232h-2.071a1.254 1.254 0 0 1 0-2.507h4.326a1.253 1.253 0 0 1 1.065 1.915l-9.848 15.844v7.06a1.253 1.253 0 0 1-.722 1.136l-9.819 4.583a1.264 1.264 0 0 1-.532.116Z" data-name="Path 808"/></svg> */}
                </div>
                <span>Filter</span>
            </button>
        </>
    );
}
export default FilterButton
